export function createMakerLinkRoutes({
  middlewareAuth,
  middlewareStoreAdmin,
}) {
  const userRoutes = [
    {
      path: "/link/:identifier",
      name: "PublicMakerLink",
      component: () => import("../../views/MakerLink/PublicMakerLink.vue"),
      props: true,
      meta: {
        hideAppChrome: true,
        title: "Maker Link",
        description: "Landing page pública do Maker Link.",
      },
    },
    {
      path: "/link/claim-for-mail",
      name: "MakerLinkClaimForMail",
      component: () =>
        import("../../views/MakerLink/MakerLinkClaimForMail.vue"),
      meta: {
        public: true,
        requiresAuth: false,
        title: "Ativar Mkr.Click",
        description: "Ative e personalize seu Mkr.Click.",
      },
    },
    {
      path: "/mkr-click/claim/:identifier",
      name: "MakerLinkClaim",
      component: () => import("../../views/MakerLink/MakerLinkClaim.vue"),
      props: true,
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: false,
        title: "Reivindicar Mkr.Click",
        description: "Associe seu Mkr.Click à sua conta.",
      },
    },
    {
      path: "/mkr-click",
      name: "MakerLinkList",
      component: () => import("../../views/MakerLink/MakerLinkList.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Meus Mkr.Clicks",
        description: "Visualize e gerencie seus Mkr.Clicks.",
      },
    },
    {
      path: "/mkr-click/create",
      name: "MakerLinkCreate",
      component: () => import("../../views/MakerLink/MakerLinkCreate.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Criar Mkr.Click",
        description: "Crie um novo Mkr.Click.",
      },
    },
    {
      path: "/mkr-click/:id/edit",
      name: "MakerLinkEdit",
      component: () => import("../../views/MakerLink/MakerLinkEdit.vue"),
      props: true,
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Editar Mkr.Click",
        description: "Gerencie o perfil, botões e destaques do seu Mkr.Click.",
      },
    },
    {
      path: "/mkr-click/:id/nfc-tags",
      name: "MakerLinkNfcTags",
      component: () => import("../../views/MakerLink/MakerLinkNfcTags.vue"),
      props: true,
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Tags NFC",
        description: "Gerencie as tags NFC do seu Mkr.Click.",
      },
    },
    {
      path: "/mkr-click/nfc-tags/unassigned",
      name: "MakerLinkUnassignedNfcTags",
      component: () =>
        import("../../views/MakerLink/MakerLinkUnassignedNfcTags.vue"),
      props: true,
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Tags NFC Não Atribuídas",
        description: "Visualize e atribua tags NFC ainda não vinculadas.",
      },
    },
  ];

  const adminRoutes = [
    {
      path: "/admin/mkr-click",
      name: "AdminsLinkProfilesPage",
      component: () =>
        import("../../views/Admins/MakerLink/AdminsLinkProfilesPage.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Mkr.Click | Perfis",
        description: "Administre os perfis Mkr.Click da plataforma.",
      },
    },
    {
      path: "/admin/mkr-click/nfc-tags",
      name: "AdminsNfcTagsPage",
      component: () =>
        import("../../views/Admins/MakerLink/AdminsNfcTagsPage.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Mkr.Click | NFC Tags",
        description: "Visualize e administre todas as NFC Tags da plataforma.",
      },
    },
    {
      path: "/admin/mkr-click/:id/editar",
      name: "AdminsLinkProfileEditPage",
      component: () =>
        import("../../views/Admins/MakerLink/AdminsLinkProfileEditPage.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Editar Mkr.Click",
        description: "Edite as informações de um perfil Mkr.Click.",
      },
    },
  ];

  return { userRoutes, adminRoutes };
}
